import { useNavigate, useSearchParams } from 'react-router-dom';
import { ProfileForm } from '@/components/onboarding/ProfileForm';
import { getPostAuthRedirect } from '@/lib/auth-intent';

/**
 * One-time post-signup profiling screen. Chromeless (no AppShell), shown right
 * after signup when the profile has not been completed. Submitting or skipping
 * routes into the app, preserving any plan/redirect intent from signup.
 */
export function WelcomeProfilePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const done = () => navigate(getPostAuthRedirect(searchParams), { replace: true });

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-lg space-y-6 animate-fade-in">
        <div className="text-center space-y-2">
          <span className="text-2xl font-bold tracking-tight text-foreground">gateco</span>
          <h1 className="text-2xl font-semibold tracking-tight">Help us set up Gateco for you</h1>
          <p className="text-sm text-muted-foreground">
            A few quick questions so we can tailor your setup. You can skip and do this later.
          </p>
        </div>
        <div className="rounded-xl border border-border bg-card p-6 shadow-sm">
          <ProfileForm onDone={done} />
        </div>
      </div>
    </div>
  );
}
